import React from 'react';
import { connect } from 'react-redux';
import {
  Button, Modal,
} from 'react-bootstrap';
import { deleteSkill } from '../../redux/reduxActions/actions';

function DeleteSkillModal(props) {
  const handleShow = () => props.show();
  const deleteSkillItem = async () => {
    props.deleteSkill(props.itemData);
    await handleShow();
  };
  const listStyle = {
    borderBottom: 'solid 1px #bdbab1', listStyleType: 'none', paddingTop: '5px', paddingLeft: '10px',
  };
  const {
	  isOpen,
	  itemData,
	  priorities,
	  jobCategories,
	  qualifications,
  } = props;
  return (
    <Modal show={isOpen} onHide={handleShow}>
      <Modal.Header closeButton>
        <Modal.Title>Are you sure you want to delete the item with this data:</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ol style={{ paddingLeft: '0px' }}>
          <li style={listStyle}>
            <strong>Priority: </strong>
            <span>{priorities[itemData.priority_id]}</span>
          </li>
          <li style={listStyle}>
            <strong>Category: </strong>
            <span>{jobCategories[itemData.category_id]}</span>
          </li>
          <li style={listStyle}>
            <strong>Skill level: </strong>
            <span>{qualifications[itemData.qualification_id]}</span>
          </li>
          <li style={listStyle}>
            <strong>Min payment: </strong>
            <span>{itemData.min_rate}</span>
          </li>
          <li style={listStyle}>
            <strong>Normal payment: </strong>
            <span>{itemData.rate}</span>
          </li>
          <li style={listStyle}>
            <strong>Additional info: </strong>
            <span>{itemData.description}</span>
          </li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleShow}>
          Close
        </Button>
        <Button variant="primary" onClick={() => deleteSkillItem()}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const mapStateToPropsTable = (state) => ({
  priorities: state.skillsReducer.priorities,
  qualifications: state.skillsReducer.qualifications,
  jobCategories: state.skillsReducer.jobCategories,
});
export default connect(mapStateToPropsTable, { deleteSkill })(DeleteSkillModal);
